<template>
  <OneCol
    :center="true"
    :borderRadius="0"
    :backgroundImage="$store.state.width > 767 ? $store.state.copy.sign.image : $store.state.copy.sign.imageMob"
    padding="0px"
    maxWidth="auto"
    :titleEnd="true"
  >
    <template v-slot:title>
      <div class="multi_wrap center">
        <div class="fit_wrap padding">
          <h1 class="no_bg">{{ $store.state.copy.sign.title }}</h1>
        </div>
        <div class="contain" :class="{ noQuote: !$store.state.copy.sign.subTitle_quote }">
          <h2
            class="sign_subtitle"
            :class="{ quote: $store.state.copy.sign.subTitle_quote }"
          >{{ $store.state.copy.sign.subTitle }}</h2>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div class="petition_wrap">
        <h2>{{ $store.state.copy.sign.petitionTitle }}</h2>
        <EnIframe
          :source="$store.state.copy.sign.EN_URL"
          goto="shareAsk"
        ></EnIframe>
      </div>
    </template>
  </OneCol>
</template>

<script>
import OneCol from "../components/template/OneCol";
import EnIframe from "../components/generic/EnIframe";

export default {
  name: "InfoSlide",
  components: {
    OneCol,
    EnIframe
  }
};
</script>
<style lang="scss" scoped>
h2 {
  width: 100%;
  text-align: left;
  font-size: 34px;
  margin: 30px 0;
  @media (max-width: 767px) {
    margin: 20px 0;
  }
}
p {
  font-size: 18px;
  line-height: 1.44;
  text-align: center;
  &:last-of-type {
    margin-bottom: 0;
  }

  &.green {
    color: #62ce00;
  }
}

.petition_wrap {
  padding: 0 20px 20px;
  max-width: 1000px;
  margin: 0 auto;
  @media (max-width: 767px) {
    padding: 0 12px 20px;
  }
}
</style>